"use client";

import { useTheme } from "next-themes";
import { Button } from "@heroui/button";
import { MdWbSunny, MdDarkMode } from "react-icons/md"; // Icônes Material plus remplies
import { FC, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Skeleton } from "@heroui/skeleton";
import clsx from "clsx";

export const ThemeSwitch: FC<{ expand: boolean }> = ({ expand }) => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  if (!mounted) {
    return <Skeleton className="w-10 h-10 rounded-lg" />;
  }

  const isLight = theme === "light";

  return (
    <Button
      onPress={toggleTheme}
      variant="light"
      radius="lg"
      isIconOnly={!expand}
      className={clsx("transition-all", {
        "justify-start px-3 w-full": expand,
        "text-warning hover:bg-warning/10": isLight && !expand,
        "text-secondary hover:bg-secondary/10": !isLight && !expand
      })}
    >
      <div className="relative w-5 h-5 flex items-center justify-center">
        <AnimatePresence mode="wait" initial={false}>
          {isLight ? (
            <motion.div
              key="sun"
              initial={{ opacity: 0, rotate: -90, scale: 0.5 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: 90, scale: 0.5 }}
              transition={{ duration: 0.2 }}
            >
              <MdWbSunny size={20} className={clsx({ "text-warning": expand })} />
            </motion.div>
          ) : (
            <motion.div
              key="moon"
              initial={{ opacity: 0, rotate: 90, scale: 0.5 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: -90, scale: 0.5 }}
              transition={{ duration: 0.2 }}
            >
              <MdDarkMode size={20} className={clsx({ "text-secondary": expand })} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {expand && (
        <span className="ml-2 text-default-600 font-medium">
          {isLight ? "Mode Clair" : "Mode Sombre"}
        </span>
      )}
    </Button>
  );
};